<template>
    <div class="request_form_card">
        <div class="header_section">
            <div class="profile_section">
                <ProfileImage :image-path="userInfo.image_path" style="width: 40px;"></ProfileImage>
                <div class="profile_info">
                    <div class="name_row">
                        <div class="player_name">
                            {{ userInfo.additional_info_name || userInfo.name }}
                            <span v-if="userInfo.is_parent_verified == 1">
                                <img style="width: 13px;" :src="require('@/assets/img/verified_parent.png')" alt="">
                            </span>
                        </div>
                    </div>
                    <div class="location">{{ userInfo.place_name }}</div>
                </div>
                <div class="age_badge">
                    <div style="line-height: 16px;">{{ userInfo.additional_info_preferred_age_team }}</div>
                    <div style="line-height: 16px; font-size: 12px; color: var(--color-main); font-weight: 700;">{{ userInfo.additional_info_player_type === 'elite' ? '엘리트 선수' : '비선출 선수' }}</div>
                </div>
            </div>
        </div>

        <div style="margin-left: 52px;">
            <div class="stats_section">
                <div class="stat_item">
                    <div class="stat_label">포지션</div>
                    <div class="stat_value">{{ userInfo.additional_info_position || userInfo.position }}</div>
                </div>
                <div class="stat_divider"></div>
                <div class="stat_item">
                    <div class="stat_label">신장</div>
                    <div class="stat_value">{{ userInfo.height || userInfo.additional_info_height }}cm</div>
                </div>
                <div class="stat_divider"></div>
                <div class="stat_item">
                    <div class="stat_label">체중</div>
                    <div class="stat_value">{{ userInfo.additional_info_weight }}kg</div>
                </div>
                <div class="stat_divider"></div>
                <div class="stat_item">
                    <div class="stat_label">주발</div>
                    <div class="stat_value">{{ transFootWay(userInfo.foot_way) || transFootWay(userInfo.additional_info_foot_way) }}</div>
                </div>
            </div>

            <div style="margin-top: 10px;">
                <div class="region_section">
                    <div style="background: #9E4CF633;" class="region_common_wrapper">
                        <div>
                            <img style="width: 12px;" :src="require('@/assets/img/region_icon_secret.png')" alt="">
                        </div>
                        <div style="font-weight: 700; color: #9E4CF6;">희망 지역</div>
                    </div>
                    <div style="background: #210F031A;" class="region_common_wrapper" v-for="each, i in regionList" :key="i + 'region_list'">
                        <div>
                            {{ each }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="intro_section">
                <div class="quote">{{ userInfo.additional_info_introduce }}</div>
                <div style="position: relative;">
                    <div class="intro_text_wrapper blur_text">
                        <div class="intro_text ellipsis_four">{{ $Util.removeYoutubeLink(userInfo.contents) }}</div>
                    </div>
                    <div @click="showRatePlanModal" class="secret_open_btn">
                        <img style="width: 18px;" :src="require('@/assets/img/lock_icon2.png')" alt="">
                        <div>시크릿 입단 요청서 열람하기</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProfileImage from '@/components/common/ProfileImage'
import { PROFILE_FOOT_WAY } from '@/Constants'
export default {
    name: 'CommonRequestForm',
    components: { ProfileImage },
    props: {
        userInfo: {
            type: Object,
            default: () => { }
        }
    },
    created() {
        this.regionList = this.userInfo.additional_info_region.split(',')
    },
    data() {
        return {
            PROFILE_FOOT_WAY: PROFILE_FOOT_WAY,
            regionList: []
        }
    },
    methods: {
        transFootWay(footWay) {
            if (footWay == 0) {
                return '양발'
            } else if (footWay == 1) {
                return '왼발'
            } else if (footWay == 2) {
                return '오른발'
            } else {
                return ''
            }
        },
        setFootWay(footWay) {
            if (footWay == PROFILE_FOOT_WAY.LEFT) {
                return '왼발'
            } else if (footWay == PROFILE_FOOT_WAY.RIGHT) {
                return '양발'
            } else {
                return '오른발'
            }
        },
        showRequestForm() {
            this.$GlobalStore.addModal('RequestReportDetailNew', { soccerhowIdx: this.userInfo.idx, is_parent_verified: this.userInfo.is_parent_verified })
        },
        showRatePlanModal() {
            this.$GlobalStore.addModal('RatePlanModal', {
                transitionName: '',
                isModalBackTransparent: true,
            })
        }
    }
}
</script>

<style scoped>
.request_form_card {
    background-color: #fff;
    border-radius: 12px;
}

/* 상단 헤더 섹션 */
.header_section {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
}

.profile_section {
    display: flex;
    gap: 12px;
    flex: 1;
    align-items: flex-start;
}

.profile-image {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
}

.profile_info {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.name_row {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.player_name {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    font-weight: 700;
    line-height: 24px;
    color: #000;
}

.tags {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
}

.tag {
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 700;
    color: #fff;
    white-space: nowrap;
}

.elite_tag {
    background-color: var(--color-main);
    border: 1px solid #FF711180;
}

.not_elite_tag {
    background-color: #c7c7c7;
}

.verified_tag {
    background: #82FFAD33;
    border: 1px solid #82FFAD;
    display: flex;
    color: #159941;
    align-items: center;
    gap: 4px;
}

.not_verified_tag {
    background: #C8C8C84D;
    border: 1px solid #c8c8c8;
    display: flex;
    align-items: center;
    gap: 4px;
    color: #989898;
}

.location {
    font-size: 12px;
    line-height: 16px;
    color: #808080;
}

.age_badge {
    background: linear-gradient(360deg, #210F03 0%, #6A6A6A 100%);
    color: #fff;
    padding: 4px 8px;
    border-radius: 8px;
    font-weight: 900;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* 중앙 스탯 섹션 */
.stats_section {
    background: #9E4CF61A;
    border-radius: 12px;
    padding: 14px 0;
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.stat_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    flex: 1;
}

.stat_label {
    font-size: 12px;
    color: #9E4CF6;
    font-weight: 700;
}

.stat_value {
    font-weight: 700;
    color: #000;
    margin-top: 7px;
}

.stat_divider {
    width: 1px;
    height: 30px;
    background-color: #9E4CF6;
}

/* 하단 소개 섹션 */
.intro_section {
    display: flex;
    flex-direction: column;
    gap: 11px;
}

.quote {
    font-weight: 700;
    color: #000;
    line-height: 24px;
}

.intro_text_wrapper {
    position: relative;
    max-height: 96px;
    overflow: hidden;
}

.intro_text {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: #c8c8c8;
}

/*용병 마커 클래스*/
.ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical
}

.region_section {
    display: flex;
    gap: 5px;
    align-items: center;
    margin-bottom: 10px;
}

.region_common_wrapper {
    font-size: 12px;
    font-weight: 500;
    line-height: 24px;
    padding: 0 8px;
    display: flex;
    align-items: center;
    gap: 6px;
    /* color: #9E4CF6; */
    border-radius: 14px;
    height: 24px;
}

.blur_text {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: #210F03;
    filter: blur(4px);
    -webkit-filter: blur(4px);
    position: relative;
}

.ellipsis_four {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 4;
    display: -webkit-box;
    -webkit-box-orient: vertical
}

.secret_open_btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    justify-content: center;
    align-items: center;
    left: 0;
    width: 100%;
    height: 48px;
    border-radius: 12px;
    background-color: #9E4CF6;
    display: flex;
    gap: 13px;
    font-size: 14px;
    font-weight: 700;
    color: #fff;
}
</style>